import {
  type FC,
  type PropsWithChildren,
} from 'react';
import {
  Navigate,
} from 'react-router-dom';
import {
  isDefined
} from '@shared/lib';
import {
  useRegionAccessAllowedQuery
} from '../api';

export const RegionAllowedOnlyRoute: FC<PropsWithChildren> = ({ children }) => {
  const { isFetching, data } = useRegionAccessAllowedQuery();
  const isRegionForbidden = isDefined(data?.isRegionAllowed) && data?.isRegionAllowed === false;
  if (isFetching) return null;
  return (isRegionForbidden ? <Navigate to='/restricted-region' replace /> : children);
};

